var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolomonIslands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.027 437.027C533.038 341.016 536.829 187.731 448.44 87.172L256 255.999L87.1719 448.44C187.731 536.829 341.015 533.038 437.027 437.027V437.027Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.974 74.974C170.985 -21.037 324.27 -24.828 424.829 63.561L256 256.003L63.562 424.829C-24.828 324.27 -21.036 170.985 74.974 74.974V74.974Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.827 63.56L63.5601 424.828C67.2121 428.983 71.0041 433.059 74.9731 437.026C78.9411 440.994 83.0181 444.786 87.1741 448.44L448.439 87.172C444.787 83.016 440.994 78.94 437.025 74.971C433.059 71.005 428.982 67.212 424.827 63.56V63.56Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.861 89.036L113.388 106.043H131.269L116.803 116.552L122.328 133.559L107.861 123.048L93.3941 133.559L98.9211 116.552L84.4541 106.043H102.336L107.861 89.036Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2 89.036L204.727 106.043H222.607L208.141 116.552L213.667 133.559L199.2 123.048L184.733 133.559L190.26 116.552L175.793 106.043H193.674L199.2 89.036Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.861 178.083L113.388 195.09H131.269L116.803 205.6L122.328 222.607L107.861 212.096L93.3941 222.607L98.9211 205.6L84.4541 195.09H102.336L107.861 178.083Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.2 178.083L204.727 195.09H222.607L208.141 205.6L213.667 222.607L199.2 212.096L184.733 222.607L190.26 205.6L175.793 195.09H193.674L199.2 178.083Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.531 133.559L159.058 150.566H176.938L162.472 161.076L167.998 178.083L153.531 167.572L139.064 178.083L144.59 161.076L130.123 150.566H148.005L153.531 133.559Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512.001,
    height: 512.001,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolomonIslands);
export default __webpack_public_path__ + "static/media/solomonIslands.7440c5e2e1e8d52887dc393fad51c678.svg";
export { ForwardRef as ReactComponent };